<template>
  <div v-if="isLoaded">
    <v-card v-if="isNewUser()" class="ma-auto mt-10" elevation="0">
      <v-card-title class="display-1 text--primary">
        Welcome
        <i>&#160;{{user}} &#160;</i> to Ikano AWS
      </v-card-title>
      <v-card-text class="body-1">
        In order for you to login to Ikano, you need to
        <ol class="mt-5">
          <li>change the temporary password</li>
          <li>setup a Multi-factor-authentication (MFA)</li>
        </ol>
      </v-card-text>
    </v-card>
    <v-card class="ma-auto mt-10 mx-5">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <!--           <v-stepper-step :complete="e1 > 1" step="1">Information</v-stepper-step>
          <v-divider></v-divider>-->
          <v-stepper-step :complete="e1 > 1" step="1">Change password</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">Setup MFA</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <!--          <v-stepper-content step="1">
            <InformationCard />
            <v-btn color="primary float-right" @click="e1 = 2">Continue</v-btn>
          </v-stepper-content>-->
          <v-stepper-content step="1">
            <ChangePassword @validPassword="change" />

            <v-btn
              @click="e1 = 2"
              :disabled="!this.$store.state.didSetPassword"
              color="primary"
              class="float-right"
            >Continue</v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <SetupMFA />

            <v-btn
              color="primary"
              class="float-right"
              :disabled="!this.$store.state.didSetMfa"
              @click="finalStep"
            >Continue</v-btn>
            <v-btn class="float-right" text @click="e1 = 1">Previous</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </div>
</template>

<script>
import ChangePassword from "../components/MainPage/ChangePassword.vue";
import SetupMFA from "../components/MainPage/SetupMFA.vue";
import Authentication from "../auth";
import router from "../router";
export default {
  name: "Main",
  components: {
    ChangePassword,
    SetupMFA,
  },
  data() {
    return {
      e1: 1,
      workspace: {},
    };
  },
  async created() {
    await this.$store.dispatch("userDetails");
  },
  methods: {
    change() {
      this.e1 = 2;
    },
    async finalStep() {
      router.push("/");
    },
    signOut() {
      this.$store.dispatch("logout");
      this.$router.go("/");
    },
    async isNewUser() {
      const flags = await this.$store.dispatch("flags");
      return flags.FORCE_RESET_PASSWORD;
    },
  },
  computed: {
    username() {
      return Authentication.getUser().sAMAccountName;
    },
    isLoaded() {
      return this.$store.state.userDetails.userDetails;
    },
    user() {
      return ` ${this.$store.state.userDetails.userDetails.cn} ` || "";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.link-large {
  font-size: 140%;
}
</style>
